import { List, ListItem } from "@material-ui/core"
import React, { useEffect, useState } from "react"
import RemoveIcon from '@material-ui/icons/Remove';


const MiniSidebar = () => {

    return (
        <div >
            <List>
                <ListItem>
                    <RemoveIcon style={{ "color": "white" }} />
                </ListItem>
                <ListItem>
                    <RemoveIcon style={{ "color": "white" }} />
                </ListItem>
                <ListItem>
                    <RemoveIcon style={{ "color": "white" }} />
                </ListItem>
                <ListItem>
                    <RemoveIcon style={{ "color": "white" }} />
                </ListItem>
                <ListItem>
                    <RemoveIcon style={{ "color": "white" }} />
                </ListItem>
                <ListItem>
                    <RemoveIcon style={{ "color": "white" }} />
                </ListItem>
            </List>
        </div>


    )

}

export default MiniSidebar